<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ ctitle }}</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态" v-if="isAdmin">
          <el-select v-model="formInline.apply_status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_name" clearable filterable
            :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年学期">
          <el-select v-model="formInline.term" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程编号">
          <el-input v-model="formInline.course_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="formInline.course_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="指导老师">
          <el-select v-model="formInline.teacher" style="width:216px;" clearable filterable :loading="loading" remote
            :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任课老师">
          <el-select v-model="formInline.class_teacher_id" style="width:216px;" clearable filterable :loading="loading"
            remote :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item v-if="isAdmin">
          <el-button type="primary" @click="handleAdd()">临时加课</el-button>
        </el-form-item>
        <el-form-item v-if="isAdmin">
          <el-button type="primary" @click="downloadFile">下载课程导入模板</el-button>
        </el-form-item>
        <el-form-item v-if="isAdmin">
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle == '导出中...'" @click="handleExportByUrl(formInline)">{{
            exportTitle }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="course_name" label="课程名称" width="160">
        </custom-table-column>
        <custom-table-column prop="course_no" label="课程编号" width="120">
        </custom-table-column>
        <custom-table-column prop="course_code" label="课程代码" width="120">
        </custom-table-column>
        <custom-table-column v-if="isAdmin" label="状态" width="150" prop="status" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="training_no" :label="`教室编号`" width="120">
        </custom-table-column> 
        <custom-table-column prop="training_name" :label="`教室名称`" width="120">
        </custom-table-column> 
        <!-- <custom-table-column prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="120">
        </custom-table-column> -->
        <custom-table-column prop="instructors" label="指导老师" width="240">
          <template slot-scope="scope" v-if="scope.row.instructors&&scope.row.instructors.length"> 
            <span>{{  [...new Map(scope.row.instructors.map(item => [item.instructor_id, item.instructor_name])).values()].join(',') }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="class_teacher" label="任课老师" width="120">
        </custom-table-column>
        <custom-table-column prop="xn" label="学年" width="140">
        </custom-table-column>
        <custom-table-column prop="term" label="学期" width="100">
        </custom-table-column>
        <custom-table-column prop="cycle_type" label="周期" width="100">
        </custom-table-column>
        <custom-table-column prop="custom_weeks" label="自定义周次" width="100">
        </custom-table-column>
        <custom-table-column prop="week_start" label="开始周次" width="100">
        </custom-table-column>
        <custom-table-column prop="week_end" label="结束周次" width="100">
        </custom-table-column>
        <custom-table-column prop="sector_start" label="开始节次" width="100">
        </custom-table-column>
        <custom-table-column prop="sector_end" label="结束节次" width="100">
        </custom-table-column>
        <custom-table-column prop="xq" label="星期" width="100">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级名称" width="180">
        </custom-table-column>
        <custom-table-column prop="people_number" label="班级人数" width="100">
        </custom-table-column>
        <custom-table-column prop="item_num" label="项目数量" width="100">
        </custom-table-column>
        <custom-table-column prop="school_enterprise_cooperation" :formatter="format_status_iss" label="是否校企合作开发课程"
          width="100">
        </custom-table-column>
        <custom-table-column prop="quality_level" label="精品课程级别" width="100">
        </custom-table-column>
        <custom-table-column prop="class_hour" label="总学时（小时）" width="140">
        </custom-table-column>
        <custom-table-column prop="class_content" label="课程内容" min-width="220">
        </custom-table-column>
        <custom-table-column prop="online_course" label="是否有线上课" width="100" :formatter="format_status_iss">
        </custom-table-column>
        <custom-table-column prop="online_course_url" label="线上课程地址" width="160">
        </custom-table-column>
        <custom-table-column prop="course_source" label="课堂教学设计主要选用课程资源" width="240">
        </custom-table-column>
        <!-- <custom-table-column prop="comment" label="备注" min-width="220" show-overflow-tooltip>
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="120" v-if="isAdmin">
          <template slot-scope="scope">
            <el-button @click="handleEditNew(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog v-if="isAdmin" :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="786px">
      <OrganDialog ref="organDia" @getSelect="getSelect" @handleOrganQuery="handleOrganQuery"></OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item label="课程名称" prop="course_name">
          <el-input v-model="ruleForm.course_name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="课程编号" prop="course_no">
          <el-input v-model="ruleForm.course_no" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="课程代码" prop="course_code">
          <el-input v-model="ruleForm.course_code" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="教室编号" prop="training_no">
          <el-input v-model="ruleForm.training_no" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="教室名称" prop="training_name">
          <el-input v-model="ruleForm.training_name" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" filterable style="width:216px;"
            :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="指导老师" prop="teacher">
          <el-select v-model="ruleForm.teacher" style="width:216px;" filterable :loading="loading" remote
            :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="指导老师" prop="teacher_id">
          <el-select v-model="ruleForm.teacher_id" style="width:216px;"
            @change="handleTeacherChange($event, 'teacher', 'teacher_number')" filterable :loading="loading" remote
            :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="任课老师" prop="class_teacher_id">
          <el-select v-model="ruleForm.class_teacher_id" style="width:216px;"
            @change="handleTeacherChange($event, 'class_teacher', 'class_teacher_number')" filterable :loading="loading"
            remote :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组织结构" prop="class_name">
          <el-input v-model="selectName" placeholder="请选择组织结构" style="width:572px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item label="周期" prop="cycle_type" >
          <el-radio-group v-model="ruleForm.cycle_type" style="width:532px;">
            <el-radio v-for="item in $store.state.cycles" :key="item" :label="item">{{ item
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自定义周次" v-if="ruleForm.cycle_type=='自定义'" prop="custom_weeks" :rules="[{ required:true, message: '请输入', trigger: 'blur' }]">
          <el-input v-model="ruleForm.custom_weeks" @input="ruleForm.custom_weeks = $event.replace(/，/g, ',').replace(/[^0-9,]/g, '')" placeholder="具体周次，逗号分隔，例1,3" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开始周次" prop="week_start">
          <el-input v-model="ruleForm.week_start" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="结束周次" prop="week_end">
          <el-input v-model="ruleForm.week_end" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开始节次" prop="sector_start">
          <el-input v-model="ruleForm.sector_start" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="结束节次" prop="sector_end">
          <el-input v-model="ruleForm.sector_end" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="星  期" prop="xq">
          <el-select v-model="ruleForm.xq" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="item in $store.state.weeks" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年学期" prop="term">
          <el-select v-model="xnTerm" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目数量" prop="item_num">
          <el-input v-model="ruleForm.item_num" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="总学时" prop="class_hour">
          <el-input v-model="ruleForm.class_hour" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="班级人数" prop="people_number">
          <el-input v-model="ruleForm.people_number" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="课堂教学设计主要选用课程资源" prop="course_source">
          <el-select v-model="ruleForm.course_source" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.courseSources" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程内容" prop="class_content">
          <el-input type="textarea" v-model="ruleForm.class_content" :rows="4" style="width:572px;"></el-input>
        </el-form-item>
        <el-form-item label="是否校企合作开发课程" prop="school_enterprise_cooperation">
          <el-select v-model="ruleForm.school_enterprise_cooperation" filterable clearable style="width:216px;"
            placeholder="请选择">
            <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="精品课程级别" prop="quality_level">
          <el-select v-model="ruleForm.quality_level" clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.qualitys" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有线上课程" prop="online_course">
          <el-select v-model="ruleForm.online_course" filterable clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="线上课程地址" v-if="ruleForm.online_course == 1"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]" prop="online_course_url">
          <el-input v-model="ruleForm.online_course_url" placeholder="请输入" style="width:572px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="备注" prop="comment">
          <el-input type="textarea" v-model="ruleForm.comment" :rows="4" style="width:572px;"></el-input>
        </el-form-item> -->
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinImport } from '@/assets/js/mixin/import';

export default {
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
    ctitle: {
      type: String,
      default: '',
    },
  },
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinValidate, mixinFormatter, mixinImport],
  data() {

    return {
      organLabel: '',
      selectName: '',
      formInline: {
        training_name: '',
        status: '',
        structure_1: '',
        structure_2: '',
        class_name: '',
        course_name: '',
        course_no: '',
        term: '',
        teacher: '',
        class_teacher_id: ''
      },
      levell: [1, 2],
      loading: false,
      ruleForm: {
        term: '',
        week_start: '',
        week_end: '',
        sector_start: '',
        sector_end: '',
        xn: '',
        xq: '',
        structure_1: '',
        structure_2: '',
        class_id:'',
        class_name: '',
        course_name: '',
        course_no: '',
        course_code: '',
        training_no:'',
        training_name:'',
        people_number: 0,
        class_content: '',
        item_num: 0,
        class_hour: 0,
        // teacher: '',
        // teacher_number: '',
        // teacher_id: '',
        class_teacher: '',
        class_teacher_number: '',
        class_teacher_id: '',
        // training_name: '',
        // training_no: '',
        // training_room_id: '',
        school_enterprise_cooperation: '',
        quality_level: '',
        online_course: '',
        online_course_url: '',
        course_source: '',
        cycle_type:'',
        custom_weeks:''
      },
      xnTerm: '',
      rules: {
        term: [{ required: true, message: '请选择', trigger: 'change' }],
        week_start: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        week_end: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        sector_end: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        sector_start: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        class_name: [
          { required: true, message: '组织结构要选择到班级', trigger: 'change' },
          { required: true, message: '组织结构要选择到班级', trigger: 'blur' },
        ],
        course_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        training_no: [{ required: true, message: '请输入', trigger: 'blur' }],
        training_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        course_no: [{ required: true, message: '请输入', trigger: 'blur' }],
        course_code: [{ required: true, message: '请输入', trigger: 'blur' }],
        // teacher_id: [{ required: true, message: '请选择', trigger: 'change' }],
        class_teacher_id: [{ required: true, message: '请选择', trigger: 'change' }],
        // training_room_id: [{ required: true, message: `请选择`, trigger: 'change' }],
        xq: [{ required: true, message: '请选择', trigger: 'change' }],
        cycle_type: [{ required: true, message: '请选择', trigger: 'change' }],
        people_number: [
          { required: true, message: '人数不能为空' },
          { validator: this.checkInt, trigger: 'blur' }
        ],
        item_num: [
          { required: true, message: '请输入' }, { validator: this.checkInt, trigger: 'blur' }
        ],
        class_hour: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkfloat, trigger: 'blur' }],
        class_content: [{ required: true, message: '请输入', trigger: 'blur' }],
        school_enterprise_cooperation: [{ required: true, message: '请选择', trigger: 'change' }],
        online_course: [{ required: true, message: '请选择', trigger: 'change' }],
        course_source: [{ required: true, message: '请选择', trigger: 'change' }],

      },
      type: 'add',
      tableName: '实训日志',
      users: [],
      exportUrl: '',
      action: '',
      downloadUrl: 'template/课程导入模版.xlsx',
      downloadName: '课程信息列表.xlsx'
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/xmhy/class/plan/import`
    if(!this.isAdmin){
      this.formInline.status = "pass"
    }
  },
  watch: {
    'xnTerm': {
      handler: function (val) {
        if (val) {
          // console.log(val.split('|'))
          this.ruleForm.term = val.split(' ')[1] ? val.split(' ')[1] : ''
          this.ruleForm.xn = val.split(' ')[0]
          // this.ruleForm = val.split(' ')
        } else {
          this.ruleForm.term = ''
          this.ruleForm.xn = ''
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.exportUrl = `${this.baseUrlt}api/xmhy/class/plan/export`;
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');
    

  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleFilter(arr){

    },
    handleTeacherChange(val, name, number) {
      this.ruleForm[name] = this.$until.getLabelName(this.users, 'id', 'name', val);
      this.ruleForm[number] = this.$until.getLabelName(this.users, 'id', 'number', val);
    },
    handleEditNew(row, extraKeys = ['id']) {
      if (row.structure_1 && row.structure_2 && row.class_name) {
        this.selectName = `${row.structure_1}-${row.structure_2}-${row.class_name}`;
      }
      this.type = 'edit'
      this.title = "编辑"
      this.ruleForm = this.assignFormObj(this.ruleForm, row, extraKeys)
      // if (row.teacher_id && JSON.stringify(this.users).indexOf(row.teacher_id) == -1) {
      //   this.users.push({ id: row.teacher_id, name: row.teacher, number: row.teacher_number })
      // }
      if (row.class_teacher_id && JSON.stringify(this.users).indexOf(row.class_teacher_id) == -1) {
        this.users.push({ id: row.class_teacher_id, name: row.class_teacher, number: row.class_teacher_number })
      }
      if (row.reports && row.reports.length > 0) {
        this.ruleForm.standards = row.reports.map(item => {
          return item.standard_name
        })
      }
      this.xnTerm = (this.ruleForm.xn ? (this.ruleForm.xn + ' ') : '') + this.ruleForm.term
      this.centerDialogVisible = true;
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: "1,3,7"
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    getOrganList() {
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.structure_2 = strArr[1];
        this.ruleForm.class_name = strArr[2];
        this.ruleForm.class_id = this.selectNode.id;
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.structure_2 = '';
        this.ruleForm.class_name = '';
      }
    },
    handleClassChange(e) {
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
      this.ruleForm.training_no = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_no', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteCourse(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateClassPlan(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    submitForm(formName) {
      if (this.ruleForm.lesson_time) {
        this.ruleForm.lesson_time = new Date(this.ruleForm.lesson_time);
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQuery1()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getClassPlanList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

@media screen and (min-width: 1000px) {
  /deep/.el-form-item__label[for=course_source],
  /deep/.el-form-item__label[for=school_enterprise_cooperation] {
    line-height: 22px;
  }
}
</style>
